export default __webpack_public_path__ + "static/media/aceiteOliva.c8af0e43.jpeg";